import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    viewChild,
} from "@angular/core";
import { Table } from "../s25-table/Table";
import { Bind } from "../../decorators/bind.decorator";
import { ListService } from "../../services/list.service";
import { ViewButtonValue } from "../s25-opt/s25.opt.component";
import { S25Util } from "../../util/s25-util";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { Proto } from "../../pojo/Proto";
import { S25TableComponent } from "../s25-table/s25.table.component";
import { ListColumn } from "../../standalone/lists/list.table.types";
import { SearchListTableHelper } from "../../standalone/lists/search.list.table.helper";
import { Item } from "../../pojo/Item";
import { S25Const } from "../../util/s25-const";
import { ContactService } from "../../services/contact.service";
import { Task } from "../../pojo/Task";
import { S25TaskEditComponent } from "../s25-task/s25.task.edit.component";
import { S25TaskStatusComponent } from "../s25-task/s25.task.status.component";
import ISODateString = Proto.ISODateString;
import { TaskTiersService } from "../../services/task/task.tiers.service";
import { S25ItemI } from "../../pojo/S25ItemI";
import { SearchService } from "../../services/search/search.service";

const stickyColumnPreference = {
    [Item.Ids.Event]: "25L_event_search_columns",
    [Item.Ids.Location]: "25L_space_search_columns",
    [Item.Ids.Resource]: "25L_resource_search_columns",
    [Item.Ids.Organization]: "25L_org_search_columns",
    [Item.Ids.Task]: "25L_task_overview_columns",
    [Item.Ids.Contact]: "25L_cont_search_columns",
} as any;

@TypeManagerDecorator("s25-ng-bulk-edit-data-list")
@Component({
    selector: "s25-ng-bulk-edit-data-list",
    template: `
        @if (!action) {
            <div>
                <h3>{{ header }}</h3>
                <a class="aw-button aw-button--outline" href="#!/home/search">Cancel</a>
                <button
                    class="aw-button aw-button--primary c-margin-bottom--single c-margin-top--single c-margin-left--quarter c-margin-right--half"
                    [disabled]="$safeNavigationMigration(selectedItems?.length) < 1"
                    (click)="goToAction()"
                >
                    Go to Actions
                </button>
            </div>
        }

        @if (isInit && !action) {
            <s25-ng-table
                [columnSortable]="true"
                [dataSource]="tableData"
                [stickyColumnSortPreference]="S25Const.itemId2Name[type]"
                [unlimitedWidth]="true"
                [pivotThreshold]="0"
                [hasSelect]="true"
                [hasSelectAll]="true"
                (selectedChange)="selectedChange($event)"
            ></s25-ng-table>
        }

        @if (!action) {
            <div>
                <a class="aw-button aw-button--outline" href="#!/home/search">Cancel</a>
                <button
                    class="aw-button aw-button--primary c-margin-bottom--single c-margin-top--single c-margin-left--quarter c-margin-right--half"
                    [disabled]="$safeNavigationMigration(selectedItems?.length) < 1"
                    (click)="goToAction()"
                >
                    Go to Actions
                </button>
            </div>
        }

        @if (isInit && action) {
            <s25-ng-bulk-edit
                [itemTypeId]="type"
                [chosenModels]="chosenModels"
                [itemIds]="selectedItems"
                (modelValueChange)="actionChange($event)"
            ></s25-ng-bulk-edit>
        }
    `,
    styles: `
        ::ng-deep s25-ng-bulk-edit-data-list tbody tr td input[type="checkbox"] {
            height: 16px !important;
        }

        ::ng-deep s25-ng-bulk-edit-data-list s25-item {
            color: rgb(37, 115, 167);
        }

        ::ng-deep s25-ng-bulk-edit-data-list s25-item s25-popover {
            display: block !important;
        }

        ::ng-deep s25-ng-bulk-edit-data-list .s25-ng-table--cell.stateTentative {
            font-style: italic;
        }

        ::ng-deep s25-ng-bulk-edit-data-list .s25-ng-table--cell.stateCancelled {
            color: #d62000;
            font-weight: 400;
        }

        ::ng-deep .nm-party--on s25-ng-bulk-edit-data-list .s25-ng-table--cell.stateCancelled {
            color: #ff837a;
        }

        ::ng-deep s25-ng-bulk-edit-data-list .s25-ng-table--cell.stateRequested_changes {
            color: #f90;
            font-weight: 400;
        }

        ::ng-deep .nm-party--on s25-ng-bulk-edit-data-list .s25-ng-table--cell.stateRequested_changes {
            color: #ffb366;
        }
        ::ng-deep s25-ng-bulk-edit-data-list s25-ng-table .italic {
            font-style: italic;
        }

        ::ng-deep s25-ng-bulk-edit-data-list s25-ng-task-edit > span {
            display: block !important;
        }

        ::ng-deep s25-ng-bulk-edit-data-list s25-ng-table s25-ng-editable-date .editable-input {
            width: 100% !important;
        }

        ::ng-deep s25-ng-bulk-edit-data-list s25-ng-table .s25-ng-table--table {
            border: 1px solid #e5e5e5;
        }

        ::ng-deep s25-ng-bulk-edit-data-list s25-ng-table tbody tr:not(:last-of-type) {
            border-bottom: 1px solid #e5e5e5;
        }

        ::ng-deep s25-ng-bulk-edit-data-list s25-ng-table .s25-ng-table--header:not(:first-child),
        ::ng-deep s25-ng-bulk-edit-data-list s25-ng-table .s25-ng-table--cell:not(:first-child) {
            border-left: 1px solid #e5e5e5;
        }

        ::ng-deep .nm-party--on s25-ng-bulk-edit-data-listt s25-ng-table .s25-ng-table--table {
            border: 1px solid rgba(255, 255, 255, 0.24);
        }

        ::ng-deep .nm-party--on s25-ng-bulk-edit-data-list s25-ng-table tbody tr:not(:last-of-type) {
            border-bottom: 1px solid rgba(255, 255, 255, 0.24);
        }

        ::ng-deep .nm-party--on s25-ng-bulk-edit-data-list s25-ng-table .s25-ng-table--header:not(:first-child),
        ::ng-deep .nm-party--on s25-ng-bulk-edit-data-list s25-ng-table .s25-ng-table--cell:not(:first-child) {
            border-left: 1px solid rgba(255, 255, 255, 0.24);
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25BulkEditDataListComponent implements OnInit {
    @Input() type: Item.Id;
    @Input() query: string;
    @Input() cacheId?: number;
    @Input() dateView?: ViewButtonValue;

    readonly tableComponent = viewChild(S25TableComponent);

    private readonly helper = new SearchListTableHelper(this.tableComponent, {
        getWorkflowChained: () => this.workflowChained,
        getUserId: () => this.userId,
        onTaskAction: (state, context) => this.onTaskAction(state, context),
    });

    isInit = false;
    startDate: ISODateString;
    endDate: ISODateString;
    S25Const = S25Const;
    data: any = [];
    userId: number;
    workflowChained: boolean;
    pageSize: number;
    sortColumn: string;
    sortOrder?: "asc" | "desc" | null;
    selectedItems: any = [];
    userName: string;
    action: boolean = false;
    header: string;
    chosenModels: S25ItemI[] = [];
    scrollHasMorePages: boolean = false;

    tableData: Table.DataSource = {
        type: "infinite scroll",
        dataSource: this.getRows,
        columns: [],
        hasMorePages: this.hasMorePages,
        customRowCount: this.getRowCount,
    };

    constructor(
        private cd: ChangeDetectorRef,
        private elementRef: ElementRef,
    ) {
        this.elementRef.nativeElement.angBridge = this;
    }

    async ngOnInit() {
        const [userId, userName, workflowPref] = await Promise.all([
            ContactService.getCurrentId(),
            ContactService.getCurrentUsername(),
            TaskTiersService.isWorkflowChained(),
        ]);
        this.header = S25Util.firstCharToUpper(S25Const.itemId2Name[this.type]) + " List";
        this.userId = userId;
        this.userName = userName;
        this.workflowChained = workflowPref;
        this.isInit = true;
        this.userName === "service25" ? (this.pageSize = 1500) : (this.pageSize = 1000);
        this.cd.detectChanges();
    }

    @Bind
    async getRows(query: Table.PaginatedQuery): Promise<Table.DataSourceResponse> {
        const data = (await this.getData(query)) || [];
        return {
            rows: data.rows.map((row: any) => this.mapToRow(data.cols, row)),
            totalRows: data.rows?.[0]?.count,
        };
    }

    async getData(tableQuery: Table.PaginatedQuery) {
        if (tableQuery.forceRefresh) this.cacheId = undefined; // If refresh is forced, don't reuse cache
        if (tableQuery.sortColumn.id !== this.sortColumn || tableQuery.sortColumn.order !== this.sortOrder) {
            // If sorting changed, reset pagination
            this.cacheId = undefined;
            this.tableComponent()!.currentPage = 0;
            tableQuery.page = 0;
        }
        this.sortColumn = tableQuery.sortColumn.id;
        this.sortOrder = tableQuery.sortColumn.order;

        if (this.type === Item.Ids.Task) {
            const taskCount = this.data?.taskCount;
            this.data = await ListService.getTaskData({
                query: this.query,
                page: tableQuery.page + 1,
                pageSize: this.pageSize,
                sortColumn: tableQuery.sortColumn.id,
                sortOrder: tableQuery.sortColumn.order,
                cacheId: this.cacheId,
            });
            if (!this.data.taskCount) this.data.taskCount = taskCount;
            this.scrollHasMorePages = this.pageSize * (tableQuery.page + 1) < this.data.taskCount;
        } else {
            this.data = await ListService.getData2({
                itemType: S25Const.itemId2Name[this.type],
                dateOption: this.dateView,
                startDate: this.startDate,
                endDate: this.endDate,
                page: tableQuery.page + 1,
                itemsPerPage: this.pageSize,
                sort: { column: tableQuery.sortColumn.id, order: tableQuery.sortColumn.order },
                query: this.query,
                cacheId: this.cacheId,
            });
            this.scrollHasMorePages = this.pageSize * (tableQuery.page + 1) < this.data.rows?.[0]?.count;
        }
        this.cacheId = this.data.cacheId;

        // Update columns in table
        let columns = this.data.cols.map((column: ListColumn) => this.helper.buildTableColumn(column));

        //bulk edit doesn't dispaly all columns like in search result list
        let displayCol: any[] = [];
        switch (this.type) {
            case Item.Ids.Event:
                displayCol = ["Name", "Title", "Reference", "Type", "Start Date", "Start Time", "State"];
                columns = columns.filter((item: any) => displayCol.includes(item.header));
                break;
            case Item.Ids.Location:
                displayCol = ["Name", "Formal Name", "Max Capacity"];
                columns = columns.filter((item: any) => displayCol.includes(item.header));
                break;
            case Item.Ids.Organization:
                displayCol = ["Name", "Title", "Type", "Accounting Code"];
                columns = columns.filter((item: any) => displayCol.includes(item.header));
                break;
            case Item.Ids.Resource:
                displayCol = ["Name", "Quantity"];
                columns = columns.filter((item: any) => displayCol.includes(item.header));
                break;
        }

        if (this.selectedItems.length > 0) this.tableComponent()!.selected = new Set(this.selectedItems);
        this.tableComponent()!.setColumns(columns);
        this.deleteTempSearch();
        this.cd.detectChanges();

        return this.data;
    }

    @Bind
    mapToRow(columns: any[], row: any): Table.Row {
        return this.helper.mapToRow(columns, row, {
            getId: (_, listRow: any) => {
                if (this.type === Item.Ids.Task) {
                    return (
                        (listRow.row[3].isTodo ? "todo" : "task") +
                        (listRow.row[6].itemCount > 1 ? "_multi_" : "") +
                        listRow.row[6].taskId
                    );
                }
                return listRow.contextId;
            },
            getName: (_, listRow: any) =>
                this.type === Item.Ids.Task ? listRow.row[0].itemName : listRow.row[1].itemName,
        });
    }

    onRefresh() {
        return this.tableComponent()!.refresh(true);
    }

    @Bind
    onTaskAction(state: Task.State, context: Table.CellCallbackContext) {
        // Update task item column
        const taskItem = context.row.cells.task_item?.instance as S25TaskEditComponent;
        if (taskItem) {
            taskItem.taskModel.itemStateId = state;
            taskItem.refresh();
        }
        // Update status column
        const status = context.row.cells.status?.instance as S25TaskStatusComponent;
        if (status) {
            status.task.task_state = state;
            status.refresh();
        }
    }

    @Bind
    getRowCount(counts: Table.RowCounts) {
        const type = S25Util.firstCharToUpper(S25Const.itemId2Name[this.type]) + (counts.total === 1 ? "" : "s");
        if (this.type === Item.Ids.Task && this.data.taskCount !== counts.total) {
            const taskItems = `Task Item${counts.total === 1 ? "" : "s"}`;
            return `${counts.total} Matching ${taskItems} with ${this.data.taskCount} Tasks`;
        }

        return `${counts.total} Matching ${type}`;
    }

    @Bind
    hasMorePages() {
        return this.scrollHasMorePages;
    }

    selectedChange(selectItem: any) {
        this.selectedItems = Array.from(selectItem);
        this.chosenModels = this.tableComponent()!
            .filteredRows.filter((r: Table.Row) => this.selectedItems.includes(r.id))
            .map((d) => ({
                itemId: d.id,
                itemName: d.name,
            }));
        this.cd.detectChanges();
    }

    goToAction() {
        this.action = true;
        this.cd.detectChanges();
    }

    goBack() {
        history.back();
    }

    actionChange(e: boolean) {
        this.action = false;
        this.cd.detectChanges();
    }

    deleteTempSearch() {
        if (this.query.indexOf("query_id") > -1) {
            const regex = /query_id=(\d+)/;
            const queryId: number = parseInt(this.query.match(regex)![1]);
            return SearchService.deleteTempSearchByQueryId(queryId, this.type);
        }
    }
}
